/* eslint-disable react/require-default-props */
import { Box, useTheme } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import './style.scss';

interface TabPanelProps {
  children: React.ReactNode;
  index: number;
  value: number;
  sx?: SxProps<Theme>,
}

function TabPanel(props: TabPanelProps) {
  const theme = useTheme();

  const scrollStyle = {
    overflow: 'hidden',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.grey.A100,
      borderRadius: 6,
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.dark,
      borderRadius: 6,
    },
  };

  const defaultStyle:SxProps<Theme> = { p: 2 };
  const {
    children, value, index, sx = defaultStyle, ...other
  } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`create-ent-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      className="tab-panel-container"
      sx={scrollStyle}
    >
      {value === index && (
      <Box sx={sx}>
        <div>{children}</div>
      </Box>
      )}
    </Box>
  );
}
export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default TabPanel;
